const SET_LOCALE = 'app/i18n/set/locale';
const ADD_MESSAGES = 'app/i18n/add/messages';

export { SET_LOCALE, ADD_MESSAGES };
